import React,{useState} from 'react'
import './Login.css'
import logo from './img/logo_black.png'
import {
    BrowserRouter as Router,
    Switch,
    Route,Link
    
  } from "react-router-dom";
  import {auth} from  './firebase.js'
  import { useHistory } from 'react-router';
import userEvent from '@testing-library/user-event';
function Login() {
    const history=useHistory();
    const signIn =(e)=>{
        e.preventDefault();
        auth.signInWithEmailAndPassword(email,password).then(auth=>{
            history.push('/')
        }).catch(error=>alert(error.message))
        
    }
    const register =(e)=>{
        e.preventDefault();
        auth.createUserWithEmailAndPassword(email,password).
        then((auth)=>{
            console.log(auth);
            if(auth){
                history.push('/')
            }
            
        }).catch(error=>alert(error.message))
        
    }

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('')
    return (
        <div className="login">
         <Link to="/"><img className="login__logo" src={logo} alt="" /></Link>
            <div className="login__container">
            <h1>Sign-in</h1>
            <form>
                <h5>E-mail</h5>
                <input type="text" value={email} onChange={e=>setEmail(e.target.value)}  />
                <h5>Password</h5>
                <input type="password" value={password} onChange={e=>setPassword(e.target.value)}  />
                <button type="submit" className="login_signInButton" onClick={signIn}>Sign In</button>
            </form>
            <p>By continuing, you agree to Amazon's <span>Conditions of Use</span> and Privacy Notice.</p>
           
           <button className="login_registerButton" onClick={register}>Create Your Amazon Account</button>
            </div>
        </div>
    )
}

export default Login
